export const AuthPortatils = ({ auth, handleChange, error }) => {

  return (<>
    <div className="row">
      <div className="col col-12 ">
        <h4>
          Acord Cessió Ordinador Departament Educació - Famílies
        </h4>
        <p>

          Des del centre posem a la teva disposició un ordinador per tal que en facis el bon ús necessari per al teu recorregut acadèmic. És la teva responsabilitat assegurar-te que es manté en bon estat al llarg de tot el curs i durant tota l’etapa educativa. El centre et pot demanar al llarg del curs diversos punts de control si així ho considera. Recorda, l’ordinador no és propietat teva, sinó que el centre te’l deixa en préstec i, en últim terme, el propietari legal és la Generalitat de Catalunya (qui pot decidir fiscalitzar-ne l’ús si ho creu convenient).  <br /> <br />

          A través d’aquest document s’estableixen les següents condicions d’obtenció d’equipament informàtic del centre:<br />

          <ul>
            <li>Rebre un dispositiu Lenovo propietat de Generalitat de Catalunya fins que aquest em sigui reclamat pel centre o, en cas de no ser-ho, fins a final de l’etapa corresponent o en cas de marxar del centre.</li>
            <li>El dispositiu pot ser requerit en qualsevol moment per l’institut per motius de manteniment.</li>
            <li>El dispositiu és entregat juntament amb un <b>carregador</b>, que s’ha de conservar.</li>
            <li><b>Mantenir</b> tot el material en el <b>mateix estat</b> amb el qual s’ha entregat.</li>
            <li>En cas de deteriorament o mal funcionament, informar immediatament i portar l’ordinador al centre per valorar la reparació. <b>En cap cas portar a reparar l’ordinador</b>, o intentar fer-li una reparació.</li>
            <li>En cas de <b>pèrdua o avaria del carregador</b>, comprar-ne un de la mateixa marca i model que el que venia amb l’ordinador.</li>
            <li>Retornar quan em sigui requerit o bé al <b>final de l’etapa</b> que correspongui el contingut complet de l’equipament: el dispositiu i el carregador en bones condicions.</li>
          </ul>

          <label>
            <input type="radio" id="authPortatils" name="authPortatils" value={auth} checked={auth === "1" ? true : false} onChange={(t) => { handleChange("1") }} required />
            Accepto i em comprometo a seguir els acords establerts anteriorment, assumint totes les responsabilitats que se’n deriven.
          </label>

          <br />

          <label>
            <input type="radio" id="authPortatils" name="authPortatils" value={auth} checked={auth === "0" ? true : false} onChange={(t) => { handleChange("0") }} required />
            No accepto i rebutjo l’ordinador.
          </label>

          <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>

        </p>


      </div>
    </div>

    <br />
  </>)
}
